module.exports = __webpack_public_path__ + "904ced3c5b15014df7a29bbf9b5c6517.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/icon-session@2x.png
// module id = 779
// module chunks = 0